import api from './api';
import types from './mutation-types';

export default {
	getPlants_({ commit }) {
		return api
			.getPlants()
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'plants',
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'plants',
						value: data !== null && data !== undefined ? data.body : null
					});

					commit(types.SEARCH_PARAM, {
						key: 'plantCd',
						value: data.body.length > 0 ? data.body[0].commCd : ''
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getCommCodes_({ commit, state, rootGetters }, { key, codeType }) {
		state.searchParams.codeType = codeType;
		return api
			.getCommCodes(state.searchParams)
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: key,
				// 		value: data !== null && data !== undefined ? data.body : null
				// 	});
				// }

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: key,
						value: data.body
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	getGroups_({ commit }, { searchParams, currentPage, pageUnit }) {
		return api
			.getGroups({ searchParams, currentPage, pageUnit })
			.then(data => {
				// if (!data.body || (data.header.code !== 200 && data.header.code !== 404)) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	commit(types.DEFAULT_ASSIGN, {
				// 		key: 'groups',
				// 		value: data !== null && data !== undefined ? data.body.resultList : null
				// 	});
				// }

				if (data.header.code === 0) {
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'groups',
					// 	value: data !== null && data !== undefined ? data.body : null
					// });

					commit(types.DEFAULT_ASSIGN, {
						key: 'resultList',
						value: data.body.resultList
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setGroups_({ commit }, param) {
		return api
			.postGroups(param)
			.then(data => {
				// if (!data.body || data.header.code !== 200) {
				// 	throw new Error(data.header.message);
				// } else {
				// 	return data.header;
				// }

				if (data.header.code === 0) {
				} else if (data.header.code === 1) {
				} else if (data.header.code === 2) {
				} else if (data.header.code === 3) {
				} else if (data.header.code === 4) {
				} else if (data.header.code === 5) {
				}

				if (data.header.code === 500) {
					// somethinig todo
				} else {
					// somethinig todo
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
